<template>
    <div class="order-detail-section mg20">
        <h3>产品信息</h3>
        <el-table :data="test" border style="margin:20px; width:97%">
            <el-table-column label="修订项" prop="title">
                <template slot-scope="scope">
                    {{scope.row.col_name}}
                </template>
            </el-table-column>
            <el-table-column label="修订后内容"  prop="ccc">
                <template slot-scope="scope">
                    <span v-html=scope.row.new_content></span>
                </template>
            </el-table-column>
            <el-table-column label="原内容" prop="bbb">
                <template slot-scope="scope" >
                    <span v-html=scope.row.old_content></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {OrderMixin} from "~/services/OrderMixin";
    export default {
        name: "product",
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            oldOrder: {
                required: false
            }
        },
        watch: {
            order(v, s) {
                if(this.order.content){
                    if(this.$route.query['flow_type'] == this.params.CONTRACT_LINE){
                        this.order.content = this.order.before_content;
                    }
                    this.test = this.order.content.products.map(item=> {
                        item.col_name = item.name;
                        let old = this.order.before_content.products.find(i=>{
                            return i.product_id == item.product_id;
                        })
                        if(old){
                            item.old_content = this.getContent(old);
                        }else{
                            item.old_content = '无';
                        }
                        item.new_content = this.getContent(item,old);
                        return item;
                    });
                    /**
                     * 有可能有删除的情况存在
                     * 需要查找出删除产品
                     */
                    let active_product = [];
                    this.test.map(i=>{
                        active_product.push(i.product_id);
                    })
                    let del_product = this.order.before_content.products.filter(item=>{
                        return !active_product.includes(item.product_id);
                    })
                    if(del_product){//说明有删除的
                        del_product.map(item=>{
                            item.old_content = this.getContent(item);
                            item.new_content = '<span style="color: red">已删除</span>'
                            item.col_name = "删除产品";
                            this.test.push(item);
                        })
                    }
                }
            }
        },
        mounted() {
            let params = {
                fields: 'id,name',
                scenario: 'all-user'
            };
        },
        data() {
            return {
                test:[
                    {
                        field:'main',
                        col_name:'',
                        new_content:'',
                        old_content:'',
                    }
                ]
            }
        },
        methods:{
            getContent(item,old=false){

                let types = {
                    1:'标准版',
                    2:'额度版'
                };

                let content = '';
                let price = "产品价格:"+item.price+"<br/>";
                let start_at = "开始时间:"+item.start_at_fomat+"<br/>";
                let end_at = "结束时间:"+item.end_at_fomat+"<br/>";
                let memo = "备注:"+item.product_memo+"<br/>";
                let type = "版本:" + types[item.type]+"<br/>";
                if(old){
                    let old_price = "产品价格:"+old.price+"<br/>";
                    let old_start_at = "开始时间:"+old.start_at_fomat+"<br/>";
                    let old_end_at = "结束时间:"+old.end_at_fomat+"<br/>";
                    let old_memo = "备注:"+old.product_memo+"<br/>";
                    let old_type = "版本:"+types[old.type]+"<br/>";

                    if(price != old_price){
                        price = '<span style="color: red">'+price+'</span>';
                    }
                    if(start_at!=old_start_at){
                        start_at = '<span style="color: red">'+start_at+'</span>';
                    }
                    if(end_at!=old_end_at){
                        end_at = '<span style="color: red">'+end_at+'</span>';
                    }
                    if(memo != old_memo){
                        memo = '<span style="color: red">'+memo+'</span>';
                    }
                    if(type != old_type){
                        type = '<span style="color: red">'+type+'</span>';
                    }
                }

                content += price;
                content += start_at;
                content += end_at;
                content += memo;
                content += type;

                return content;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/finance/product.vue